import { IPermanentMedicament } from '../Components/PermanentMedication/PernamentMedicationItem';

export const prepareDefaultDataFromPermanentMedication = (
	items: IPermanentMedicament[],
) => {
	const medicaments: { hvlp: any[]; iplp: any[] } = { hvlp: [], iplp: [] };

	items.forEach(item => {
		const { formType } = item.data;

		const isHVLP = formType === 'hvlp';
		const isIPLP = formType === 'iplp';

		if (isHVLP) {
			medicaments.hvlp.push(item.data);
		} else if (isIPLP) {
			medicaments.iplp.push(item.data);
		}
	});

	return { formData: { default: { medicaments } } };
};
